ALLOWED_COOKIES = false;

ORIGINAL_COOKIE =
    Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') ||
    Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');

ALLOWED_COOKIES = (getOriginalCookie("ALLOWED_COOKIES") == "yes");

TEMP_COOKIES = "";

if (ORIGINAL_COOKIE && ORIGINAL_COOKIE.configurable) {
    Object.defineProperty(Document, 'cookie', {
        get: function() {
            if (ALLOWED_COOKIES) {
            return ORIGINAL_COOKIE.get.call(Document);
          } else {
            return TEMP_COOKIES;
          }
        },
        set: function (val) {
            if (ALLOWED_COOKIES) {
                ORIGINAL_COOKIE.set.call(document, val);
            } else {
                if (ALLOWED_COOKIES || getCookie("ALLOWED_COOKIES") == "yes") {
                ORIGINAL_COOKIE.set.call(document, val);
              } else {
                console.log("Cookies have not been accepted, adding temp cookie");
                TEMP_COOKIES += val;
              }
            }
        }
    });

    Object.defineProperty(document, 'cookie', {
        get: function() {
          if (ALLOWED_COOKIES) {
            return ORIGINAL_COOKIE.get.call(document);
          } else {
            return TEMP_COOKIES;
          }
        },
        set: function (val) {
            if (ALLOWED_COOKIES) {
                ORIGINAL_COOKIE.set.call(document, val);
            } else {
                console.log("Cookies have not been accepted, adding temp cookie");
                TEMP_COOKIES += val;
            }
        }
    });
}

function enableCookies() {
    ALLOWED_COOKIES = true;
    var d = new Date();
    d.setTime(d.getTime() + (10* 365 * 24 * 60 * 60 * 1000)); // 10 years from now
    document.cookie = "ALLOWED_COOKIES=yes; expires=" + d.toUTCString() + "; path=/";
}

//thanks w3 schools
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function getOriginalCookie(cname) {
    var name = cname + "=";
    var ca = ORIGINAL_COOKIE.get.call(document).split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}